import isNil from 'lodash/isNil';
export const defaultPx = prop => typeof prop === 'number' ? `${prop}px` : prop;
export const asIs = t => t;
export const toCss = propsMap => props => Object.keys(propsMap).filter(k => !isNil(props[k])).map(k => {
  const {
    name,
    apply
  } = propsMap[k];
  const value = apply(props[k]);
  return `${name}: ${value};`;
}).join('');